import { Component, Input } from '@angular/core';

export type ModalPaddingSize = 'none' | 'sm' | 'md' | 'lg';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.scss']
})
export class ModalComponent {
  @Input() padding: ModalPaddingSize = 'md';

  get modalPaddingSize(): string {
    return `modal-padding-${this.padding}`;
  }

}
